(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    /**
   * Three Marks - Actualización dinámica del precio en el botón
   */
  (function() {
    const component = document.currentScript?.closest('add-to-cart-component');
    if (!component) return;

    const priceElement = component.querySelector('.tm-atc-price');
    const productId = component.dataset.productId;
    
    if (!priceElement) return;

    // Obtener datos del producto
    const productJsonScript = document.querySelector(`script[data-product-json][data-product-id="${productId}"]`);
    let productData = null;
    
    if (productJsonScript) {
      try {
        productData = JSON.parse(productJsonScript.textContent);
      } catch (e) {
        console.warn('TM: Error parsing product JSON');
      }
    }

    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      return amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';
    }

    function getVariantPrice(variantId) {
      if (!productData?.variants) return null;
      const variant = productData.variants.find(v => String(v.id) === String(variantId));
      return variant ? variant.price : null;
    }

    function updatePrice() {
      const form = component.closest('form') || component.closest('product-form-component')?.querySelector('form');
      if (!form) return;

      const variantInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');
      
      const variantId = variantInput?.value;
      const quantity = parseInt(quantityInput?.value) || 1;
      
      let price = getVariantPrice(variantId);
      
      // Fallback al precio inicial
      if (price === null) {
        price = parseInt(priceElement.dataset.initialPrice) || 0;
      }

      const total = price * quantity;
      priceElement.textContent = formatMoney(total);
    }

    // Bind events
    const form = component.closest('form') || component.closest('product-form-component')?.querySelector('form');
    
    if (form) {
      // Cambios en cantidad
      const quantityInput = form.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.addEventListener('change', updatePrice);
        quantityInput.addEventListener('input', updatePrice);
      }

      // Botones +/-
      form.querySelectorAll('button[name="minus"], button[name="plus"]').forEach(btn => {
        btn.addEventListener('click', () => setTimeout(updatePrice, 50));
      });

      // Observer para cambios de variante
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        const observer = new MutationObserver(updatePrice);
        observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      }
    }

    // Cambios en selects de variante
    document.querySelectorAll('.variant-option__select').forEach(select => {
      select.addEventListener('change', () => setTimeout(updatePrice, 100));
    });

    // Evento custom del tema
    document.addEventListener('variant:changed', updatePrice);

    // Update inicial
    updatePrice();
  })();
  } catch(e) { console.error(e); }
})();

})();
